import Field from "@hudson/ui/components/FormFields/Field";
import Input from "@hudson/ui/components/FormFields/Input";
import creditCardType from "credit-card-type";
import CreditCardIcon from "../CreditCardIcon";

function luhn(value: string) {
  // Accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(value)) return false;
  if (!/[^0-\s]+/.test(value)) return false; // All zeros

  // The Luhn Algorithm. It's so pretty.
  let nCheck = 0,
    bEven = false;
  value = value.replace(/\D/g, "");
  if (value.length < 12) return false;

  for (var n = value.length - 1; n >= 0; n--) {
    var cDigit = value.charAt(n),
      nDigit = parseInt(cDigit, 10);
    if (bEven && (nDigit *= 2) > 9) nDigit -= 9;
    nCheck += nDigit;
    bEven = !bEven;
  }
  return nCheck % 10 == 0;
}

function Number({
  className = "",
  errorMessage,
  errorInvalid,
  errorType,
  fieldName,
  label,
  invalidTypes,
  requiredPlaceholder,
}: {
  className?: string;
  errorMessage: string;
  errorInvalid: string;
  errorType: string;
  fieldName: string;
  label: string;
  invalidTypes: string[];
  requiredPlaceholder?: string;
}): JSX.Element | null {
  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, onBlur) => (
        <div className="flex gap-x-4">
          <Input
            autoComplete="cc-number"
            className="w-60"
            inError={inError}
            mask={/^3[47]/.test(String(value)) ? "9999 999999 99999" : "9999 9999 9999 9999 999"}
            onBlur={onBlur}
            onChange={onChange}
            required={Boolean(errorMessage)}
            requiredPlaceholder={requiredPlaceholder}
            value={value ? String(value) : ""}
          />
          <CreditCardIcon number={String(value)} />
        </div>
      )}
      fieldName={fieldName}
      fieldValidations={{
        required: errorMessage,
        validate: {
          validNum: (v) => !v || luhn(v) || errorInvalid,
          validType: (v) =>
            !(creditCardType(v)[0]?.type == "american-express" && invalidTypes.includes("amex")) ||
            errorType,
        },
      }}
      label={label}
    />
  );
}

export default Number;
